import { Check } from 'lucide-react';

/** Item visuel d'une modalité de paiement, aligné sur le style de `BankAccountRibSelector`. */
export const PaymentModeOption = ({
  icon,
  title,
  description,
  selected,
  onClick,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`group relative flex items-start gap-4 p-4 rounded-xl border-2 w-full text-left cursor-pointer transition-all duration-200 ${
      selected
        ? 'bg-green-50 border-green-500 shadow-md shadow-green-100'
        : 'bg-white border-gray-200 hover:border-primary/50 hover:shadow-sm'
    }`}
  >
    {/* Icône */}
    <div
      className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center transition-colors ${
        selected
          ? 'bg-green-500 text-white'
          : 'bg-gray-100 text-gray-500 group-hover:bg-primary/10 group-hover:text-primary'
      }`}
    >
      {icon}
    </div>

    {/* Contenu */}
    <div className="flex-1 min-w-0">
      <div className={`text-sm font-bold mb-1 ${selected ? 'text-green-700' : 'text-gray-800'}`}>
        {title}
      </div>
      <p className="text-sm text-gray-500">{description}</p>
    </div>

    {/* Indicateur de sélection */}
    <div className="flex-shrink-0">
      <div
        className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${
          selected
            ? 'bg-green-500 border-green-500'
            : 'border-gray-300 group-hover:border-primary/50'
        }`}
      >
        {selected && <Check className="w-4 h-4 text-white" />}
      </div>
    </div>
  </button>
);
